// removed by extract-text-webpack-plugin
module.exports = {"serverSyncContainer":"ServerSync__serverSyncContainer___3srrW","serverSync":"ServerSync__serverSync___3boeT","serverSyncStaging":"ServerSync__serverSyncStaging___1A2Ct"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ServerSync/ServerSync.scss
// module id = 1191
// module chunks = 1